import type { Role } from '@soc/shared';
import { useGetMeQuery } from '../../app/api';

/**
 * Auth state, sourced from `GET /auth/me`. RTK Query is the single source of
 * truth — the httpOnly cookie is the real session, and a 401 (after a silent
 * refresh attempt in the base query) means logged out.
 */
export function useAuth() {
  const { data, isLoading, isError, refetch } = useGetMeQuery();
  return {
    user: data ?? null,
    isAuthenticated: !!data,
    isLoading,
    isError,
    role: (data?.role ?? null) as Role | null,
    refetch,
  };
}
